// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"newssidebar-module--sidebar--1EA4V","sidebarlink":"newssidebar-module--sidebarlink--3wT2o","innersidebar":"newssidebar-module--innersidebar--ngda3"};